import axios from 'axios'
import { API_BASE, apiErrorHandler } from '../api'
import { objectToSnakeCase } from '../utils'
import Auth from '../auth'

const EXPENSE_ENDPOINT = `${API_BASE}expenses/`

export default class ExpenseAPI {
  constructor(cls) {
    this.cls = cls
  }
  static create(cls) {
    return new ExpenseAPI(cls)
  }

  create(expense) {
    const data = this.cls.toAPI(expense)
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    return axios
      .post(EXPENSE_ENDPOINT, data, options)
      .then(response => this.cls.fromAPI(response.data))
      .catch(apiErrorHandler({ apiName: 'Create Expense API error' }))
  }

  update(expense, fields = [], excludeFields = []) {
    // NIP 3/11/20 Commenting this out temporarily - not sure why it's being thrown
    // this.cls.checkIsInstance(expense, 'The `expense` argument')

    const url = `${EXPENSE_ENDPOINT}${expense.id}/`
    let data = this.cls.toAPI(expense, fields, excludeFields)
    const options = {
      headers: Auth.getHeaders(),
    }
    return axios
      .patch(url, data, options)
      .then(response => this.cls.fromAPI(response.data))
      .catch(apiErrorHandler({ apiName: 'Update Expense API error', rethrowErrors: true }))
  }

  delete(expense) {
    const url = `${EXPENSE_ENDPOINT}${expense.id}/`
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    return axios
      .delete(url, options)
      .catch(apiErrorHandler({ apiName: 'Delete Expense API error' }))
  }
}
